import styled from "styled-components";
import { Row, FormControl, ControlLabel } from "react-bootstrap";
import { CtaButton } from "../../Subscriptions/Common/index.style";

export const Container = styled(Row)`
  max-width: 1280px;
  width: 100%;
  margin-top: 3em;
`;

export const Form = styled.form`
  width: calc(100% + 2em);
  padding: 2em 0;
`;

export const Title = styled.h2`
  font-size: 1.7rem;
`;

export const Button = styled(CtaButton)`
  margin: 1.5em 2em 0 -1em;
  border: 2px solid #0071bc;
  color: #0071bc;
  width: 150px;
  height: 40px;

  &:hover,
  &:focus {
    background-color: #0071bc;
    border: 2px solid #0071bc;
    color: white;
  }

  @media (max-width: 800px) {
    margin-top: 1em;
    float: right;
  }
`;

export const Label = styled(ControlLabel)`
  float: left;
  font-size: 18px;
  color: #636464;
  font-family: SANS-SERIF;
  padding-top: 9px;
  font-weight: normal;
  text-transform: capitalize;
`;

export const TextArea = styled(FormControl)`
  // will override height property, only for the TextArea component
  height: 150px !important;
`;

